/* (ignored) */


//////////////////
// WEBPACK FOOTER
// vertx (ignored)
// module id = 174
// module chunks = 0